<template>
  <div class="addcourse addcourseware coursewareModle commonAddcourse">
    <!--面包屑-->
    <div class="crumbs">
      <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
    <span>首页</span>>
    <span><router-link :to="{name:'CourseWare'}">教学课件</router-link></span> >
      <span v-if="cutOut === 'Modify'">修改课件</span>
      <span v-else>添加课件</span>
    </div>
    <!--搜索框-->
    <div class="search medicalNews medical">
      <el-form ref="form" :rules="rules" :model="form" label-width="100px">
        <el-row>
          <el-col :span="11">
            <el-form-item :span="10" label="课件名称  :" prop="CurseName">
              <el-col :span="20">
                <el-input v-model="form.CurseName" placeholder="请输入课件名称"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :span="10" label="课件分类  :">
              <el-col :span="20">
                <el-select style="width: 100%;" v-model="selectCurse" placeholder="请选择">
                  <el-option v-for="item in cursetypeList"
                             :key="item.catalogName"
                             :label="item.catalogName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="scient">
            <el-form-item :span="10" label="学科分类  :" >
              <el-col :span="20">
                <el-select style="width: 100%;" v-model="selectSubject" placeholder="请选择">
                  <el-option v-for="item in subjectList"
                             :key="item.id"
                             :label="item.catalogName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item :span="10" label="创建人  :">
              <el-col :span="20">
                <el-input v-model="founder" placeholder="请输入创建人" :disabled="true"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item :span="10" label="关键词  :">
              <el-col :span="20">
                <el-input v-model="keywords" placeholder="请输入关键词，用逗号隔开"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="是否公开" prop="resource">
              <el-radio-group v-model="form.resource" @change="_radioSelect">
                <el-radio label="公开"></el-radio>
                <el-radio label="私人"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="13" v-show="scopeShow">
            <el-form-item :span="10" label="开放范围  :">
              <el-col :span="20">
                <el-input @focus="_openScope" v-model="openMember" placeholder="请输入开放范围"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24">
            <el-form-item :span="10" label="备注  :">
              <el-col :span="22">
                <el-input v-model="remark" :maxlength="200" placeholder="请输入备注" type="textarea"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--切换-->
    <div class="tabs-content">
      <div class="addCourse">
        <div v-show="addBtn" class="addBtn" @click="_addBtn">{{text}}</div>
      </div>
      <div class="tabs-text">
        <i class="arrow_first">></i>
        <i class="arrow_second">></i>
        <el-tabs v-model="activeName1" @tab-click="handleClick">
          <el-tab-pane label="1.选择相关影像" name="first" ref="addsTab">
            <div class="limit" >
              <p-table :operationWidth="operationWidth" :head="head" :data="data" :autoheight="autoheight" :operation="operation" @_operation="_operation_"></p-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="2.选择相关病例" name="second" ref="addsTab">
            <div class="limit">
              <p-table :head="headVal" :data="dataVal" :operation="operation2" :autoheight="autoheight"  @_operation="_operation2_"></p-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="3.上传其他附件" name="third">
            <div class="file-block"  ref="files" >
            <upload  @fileChange="fileChange" @fileRemove="fileRemove" :updateFileList="updateFileList" :updatePicList="updatePicList"></upload>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--确定取消按钮-->
    <div class="btn-box">
      <el-button @click="_AddCourse('form')" class="save">确定</el-button>
      <el-button @click="_returnback" class="cancel">取消</el-button>
    </div>
    <!--从本院影像获取-->
    <pops v-if="hospitalPop" :show="hospitalPop" :title="'从本院影像中选择'" @closePop="closeHospit" :class="'mrDialog'" :width="'980px'">
      <pImage @_popshow="receiveVal" @_popClose="receiveClose" :studyList="studyList"></pImage>
    </pops>
    <!--开放范围弹框-->
    <openFlagPop ref="getFlag" @openMemberVal="openMemberVal" @openMemberData="openMemberData"></openFlagPop>
    <!--从病例中选择弹框-->
    <pops v-if="popCase" :show="popCase" :title="'从病例库中选择'" @closePop="closePopCase" :width="'73%'">
      <div class="popScore popCourse queryCourse">
        <div class="popContent">
          <div class="leftCont medicalRecord_left">
            <div class="margin10_box medicalRecord_left">
              <collapse-medical-record @tabChange="tabChange" :tabs="tabs" @changeColl="changeColl"
                                       @delPerson="delPerson" @personClick="personClick"
                                       @searchClick="searchClick" :personList="personList" @addPersonList="addPersonList" :treeData="treeData"
                                       @treeNodeClick="treeNodeClick" :titleList="titleList" :filterText="filterText">
              </collapse-medical-record>
            </div>
          </div>
          <div class="rightCont">
            <div class="rightTitle">
              <span class="alreadyChoose">当前您已选择<i class="difColor">{{number}}</i>条病例</span>
              <span class="saveInput">
                <input v-model="search" class="_input" placeholder="请输入关键字搜索" type="text">
                <i class="point el-icon-search _inputTable" @click="tableCaseList"></i>
              </span>
            </div>
            <div class="borderCont">
              <zTable :head="head3" :data="tableData" :TableData="TableData" :height="height" @tableVal="tableVal" @ValLength="ValLength" ref="getSelection"></zTable>
              <page :total="page.total" :allPage="page.allPage" :pagerCount="5" :currentPage="page.currentPage" @current-page="__currentPage" @page-size="__pageSize"></page>
            </div>
          </div>
        </div>
        <!--添加取消按钮-->
        <div class="btn-box">
          <el-button class="save" @click="addDataVal">添加</el-button>
          <el-button @click="_cancelCanse" class="cancel">取消</el-button>
        </div>
      </div>
    </pops>
    <!--病例详情弹框-->
    <casePop ref="getCase"></casePop>

    <aycanImages ref="aycanImages" :hospitalId='params_image.hospitalId' :studyPk='params_image.studyPk' :studyUid='params_image.studyUid' ></aycanImages>
  </div>
</template>

<script type="text/ecmascript-6">
  import btns from '@/components/common/button/buttons'
  import collapse from '@/components/common/collapse/collapse'
  import tabs from '@/components/common/tabs/tabs'
  import tree from '@/components/common/tree/tree'
  import radiusInput from '@/components/common/radiusInput/radiusInput'
  import pTable from '@/components/common/tables/publicTable'
  import zTable from '@/components/common/tables/table'
  import alonebutton from '@/components/common/button/aloneButton'
  import pops from '@/components/common/pops/pop'
  import openFlagPop from '@/components/common/pops/openFlagPop'
  import casePop from '@/components/common/pops/casePop'
  import page from '@/components/common/page/page'
  import upload from "@/components/common/upload/uploadFile1"
  import pImage from '@/components/common/Image/imageSelection'
  import collapseMedicalRecord from '@/components/common/collapseMedicalRecord/collapseMedicalRecord'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import {message} from '@/common/js/messages'
  import {nomalTime} from '@/common/js/time'
  import {getLocalStorage, saveLocalStorage, clearLocalStorage} from '@/common/js/localStorage'
  import {changehosArea,changeAge,changeGender,changeSex,changeclinicType} from '@/common/js/change'

  import aycanImages from '@/components/common/base/aycanImages'
  export default {
    components: {
      collapse,
      tabs,
      tree,
      radiusInput,
      pTable,
      zTable,
      alonebutton,
      collapseMedicalRecord,
      openFlagPop,
      pops,
      casePop,
      page,
      upload,
      pImage,
      btns,
      aycanImages
    },
    data() {
      return {
        autoheight:this.getH(),
        page: {
          total: 0,
          currentPage: 0,
          pageSize: 30
        },
        hospitalPop: false,
        popCase: false,
        scopeShow: false,
        activeName1: 'first',
        activeName: '1',
        search:'',
        openMember:'',
        openMemberList: [],
        updateFileList: [],
        updatePicList: [],
        number:'0',
        operationWidth: '100%',
        activeType: 'first',
        text: '从本院影像选择',
        addBtn: true,
        selectCurse: '',
        form: {
          CurseName: '',
          CurseType: '',
          resource: '公开'
        },
        deptName: '',
        selectSubject: '所有',
        founder: '',
        medicDetail:'',
        isPerson: false,
        showCheckBox: false,
        treeData: [],
        height: 290,
        openFlag: '1',
        remark: '',
        cutOut: '',
        medicalVal:'',
        titleList: [
          { title: "自定义分类", name: "4" },
          { title: "按诊断分类", name: "1" },
          { title: "按部位分类", name: "2" },
          { title: "按科室分类", name: "3" }
        ],
        personList: [],
        tabs: [
          {label: '公共分类', name: '0'},
          {label: '个人分类', name: '1'}
        ],
        rules: {
          CurseName: [
            {required: true, message: '请输入课件名称', trigger: 'blur'}
          ],
          resource: [
            {required: true, message: '请选择是否公开', trigger: 'change'}
          ]
        },
        options: [{
          value: '0',
          label: '男'
        }, {
          value: '1',
          label: '女'
        }],
        sex: '',
        options2: [{
          value: '1',
          label: '岁'
        }, {
          value: '2',
          label: '月'
        }],
        garal: '岁',
        tableKeyWords:'',
        filterText:'',
        deptId:'',
        commonUserId:'',
        keywords:'',
        rightTabActive: "1",
        hospitalId: '',
        head: [
          {
            props: 'hospitalName',
            label: '医院名称',
            width: '10%'
          },{
            props: 'patientId',
            label: '患者编号',
            width: '12%'
          },{
            props: 'accessionNumber',
            label: '检查号',
            width: '10%'
          },{
            props: 'examTypeName',
            label: '类型',
            width: '12%'
          },
          {
            props: 'patientName',
            label: '姓名',
            width: '8%'
          },
          {
            props: 'patientSex',
            label: '性别',
            width: '8%'
          },
          {
            props: 'patientAge',
            label: '年龄',
            width: '8%'
          },
          {
            props: 'clinicType',
            label: '就诊类别',
            width: '12%'
          },
          {
            props: 'examBodyName',
            label: '检查项目',
            width: '12%'
          },
          {
            props: 'examDate',
            label: '检查时间',
            width: '18%'
          }
        ],
        headVal:
          [
            {
              props: "caseName",
              label: "病例名称"
            },
            {
              props: "privateType",
              label: "访问权限"
            },
            {
              props: "caseSex",
              label: "性别"
            },
            {
              props: "caseAge",
              label: "年龄"
            },
            {
              props: "createDateStr",
              label: "创建时间"
            },
            {
              props: "creatorName",
              label: "创建人"
            }
          ],
        head3: [
          {
            props: "caseName",
            label: "病例名称"
          },
          {
            props: "privateType",
            label: "访问权限"
          },
          {
            props: "caseSex",
            label: "性别"
          },
          {
            props: "caseAge",
            label: "年龄"
          },
          {
            props: "createDateStr",
            label: "创建时间"
          },
          {
            props: "creatorName",
            label: "创建人"
          }
        ],
        data: [],
        dataVal: [],
        groupIds: [],
        tableData: [],
        TableData:[],
        operation: [
          {
            name: '阅片',
            operation: '',
            class: 'icon-yuepian'
          },
          {
            name: '移除',
            operation: '',
            class: 'icon-yichu'
          }
        ],
        operation2: [
          {
            name: '查看',
            operation: '',
            class: 'icon-chakan'
          },
          {
            name: '移除',
            operation: '',
            class: 'icon-yichu'
          }
        ],
        cursetypeList: [],
        subjectList: [],
        caseList: [],
        attachList: [],
        oldAttachList: [],
        typeName: '',
        studyList:[],
        params_image:{//阅片数据
          hospitalId:'',
          studyPk:'',
          studyUid:'',
        }
      }
    },
    mounted() {
      let  that = this
      window.addEventListener('resize', () => {
        setTimeout(() => {
          that.getH()
          that.$refs.files.style.height = that.autoheight + 'px'
        }, 50)
      })
      that.$refs.files.style.height = that.autoheight + 'px'
    },
    methods: {
      getH(){
        this.autoheight = document.body.clientHeight - 50 - 40 - 241 - 15 - 55 - 75  //header + crumb + block1 + mb + tabs + buttons
      },
      __pageSize(payload) {
        this.page.pageSize = payload
        this.tableCaseList()
      },
      __currentPage(val) {
        this.page.currentPage = val
        this.getTableList()
      },
      fileChange(val) {
        this.oldAttachList = val
      },
      fileRemove(val) {
        this.attachList.splice(this.attachList.indexOf(val[val.length - 1]), 1)
      },
      _operation_(payload) {
        if (payload.operation === 'icon-yuepian') {
          this.params_image.hospitalId = this.data[payload.index].hospitalId;
          this.params_image.studyPk = this.data[payload.index].studyPk+"";
          this.params_image.studyUid = this.data[payload.index].studyUid;
          this.$nextTick(() => {
            this.$refs.aycanImages.getConsultImages();
          })
          // let Aycan = {
          //   hospitalId:this.data[payload.index].hospitalId,
          //   studyPk:this.data[payload.index].studyPk,
          //   studyUid:this.data[payload.index].studyUid,
          // }
          // http.post('/edu/prepareAycan.json', Aycan).then(res => {
          //   if (res.data.code == "0000") {
          //     window.open(res.data.model,'_blank');
          //   }else{
          //     message('该病人无初始影像',false);
          //   }
          // }).catch(() => {
          // })
        } else if (payload.operation === 'icon-yichu') {
          this.$confirm('是否确定要移除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.data.splice(payload.index, 1)
          })
        }
      },
      _operation2_(payload) {
        if (payload.operation === 'icon-chakan') {
          this.$refs.getCase.openCase(payload.id)
        } else if (payload.operation === 'icon-yichu') {
          this.$confirm('是否确定要移除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.dataVal.splice(this.dataVal.indexOf(payload), 1)
          })
        }
      },
      _addBtn() {
        if (this.text === '从本院影像选择') {
          this.hospitalPop = true
          this.studyList = this.data
          let isModify = getLocalStorage('isModify')
          if(isModify) {
            saveLocalStorage(true, 'trigger')
          }
        } else if (this.text === '从病例库中选择') {
          this.TableData = []
          this.popCase = true
          this._getTreeData()
          this._getTreeData(1)
          this.tableCaseList()
        }
      },
      _openScope() {
        this.$refs.getFlag.openFlag()
      },
      closeHospit(payload) {
        this.hospitalPop = payload;
      },
      receiveClose(){
        this.hospitalPop = false
      },
      closePopCase(payload) {
        this.popCase = payload
      },
      _cancelHos() {
        this.pop = false
      },
      _cancelCanse() {
        this.popCase = false
      },
      handleClick(tab, event) {

        // console.log(tab, event);
      },
      receiveVal(val) {
        debugger;
        if(val.length!==0) {
            this.data = val
            for (let i = 0; i < this.data.length; i++) {
           this.data[i].examDate = nomalTime(this.data[i].examDate);
           this.data[i].patientSex =this.data[i].patientSex;
           this.data[i].hospitalName =this.data[i].hospitalName;
           this.data[i].clinicType = this.data[i].clinicType;
           if(this.data[i].patientAge == undefined){
             this.data[i].patientAge = ""
           }else if(this.data[i].patientAge.indexOf('岁') > -1){
                this.data[i].patientAge= this.data[i].patientAge
            }else{
               this.data[i].patientAge = this.data[i].patientAge + changeAge(this.data[i].ageUnit)
            }
          this.hospitalPop = false
          }
        }
      },
      tableVal(val) {
        this.medicalVal = val
      },
      ValLength(val) {
        this.number = val
      },
      addDataVal() {
        this.dataVal = []
        this.$refs.getSelection.getList();
        this.popCase = false
        this.dataVal = this.medicalVal
      },
      _getTreeData(privateType = 0, keyWord='', subType) {
        let parmars = {
          privateType,
          keyWord,
          subType
        };
        http.post("/catalog/queryCaseCatalogTree.json", parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            if (privateType === 0) {
              this.allTreeData = res.data.model;
              this.changeColl('1')
            } else {
              this.oldPersonList = res.data.model;
              this.personList = res.data.model;
            }
          }
        });
      },
      addPersonList(val) {
        this.$prompt('请输入病例名', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
          // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          // inputErrorMessage: '邮箱格式不正确'
        }).then(({ value }) => {
          let parmars = {
            privateType: '1',
            catalogName:　value
          }
          http.post('catalog/addCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '提交成功'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      changeColl(playlod) {
        this.defaultTreeChecked = []
        this.filterText = ''
        this.treeData = []
        setTimeout(() => {
          // 1==>部位 2==>诊断 3==>科室
          let [flag, arr] = ['DIANOG', []];
          if (playlod === '1') {
            flag = 'DIANOG';
          } else if (playlod === '2') {
            flag = 'PART';
          } else if (playlod === '3') {
            flag = 'DEPT';
          } else {
            flag = 'CUSTOMER';
          }
          this.treeData = []
          arr = this.allTreeData.filter(item => item.subType === flag)
          for (let item of arr) {
            if (item.parentId === 0) {
              this.treeData.push({
                id: item.id,
                label: item.catalogName,
                children: this.allTreeData.filter(c => c.parentId === item.id)
              })
            }
          }
          for (let item of this.treeData) {
            if (item.children.length > 0) {
              for (let cItem of item.children) {
                cItem.label = cItem.catalogName
              }
            }
          }
        }, 400)
      },
      treeNodeClick(val) {
        this.getTableList(this.personFlag, val.id)
      },
      delPerson(val) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          let parmars = {
            id: val.id
          }
          http.post('catalog/deleteCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      getTableList(privateType=0,catalogId) {
        let parmars = Object.assign({
          catalogId,
          privateType,
          keyWord: this.tableKeyWords
        }, this.page)
        http.post('caselib/queryCaseList.json', parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.tableData = res.data.model
            this.page.total = res.data.totalItem
            this.page.currentPage = res.data.currentPage
            for (let item of this.tableData) {
              item.caseSex = _.SEXOBJ[item.caseSex]
              item.privateType = _.privateType[item.privateType]
               if(item.caseAge!==undefined){
                 if (item.ageUnit === '4') {
                   item.caseAge = item.caseAge + '岁'
                 } else if (item.ageUnit === '3') {
                   item.caseAge = item.caseAge + '月'
                 } else if (item.ageUnit === '2') {
                   item.caseAge = item.caseAge + '周'
                 } else if(item.ageUnit === '1'){
                   item.caseAge = item.caseAge + '天'
                 } else if(item.ageUnit === '5'){
                   item.caseAge = item.caseAge + '小时'
                 }
               } else {
                 item.caseAge = ''
             }
            }
            this.TableData = this.dataVal
          }
        })
      },
      searchClick(val) {
        this.filterText = val
        this.personList = this.oldPersonList.filter(item => item.catalogName.includes(val))
      },
      tableCaseList() {
        this.tableKeyWords = this.search
        this.getTableList()
      },
      rightTabChange(payload) {
        this.activeName = payload.name;
        this.rightTabActive = payload.name;
      },
      _radioSelect(tab) {
        if (tab === '公开') {
          this.scopeShow = false
          this.openFlag = '1'
        } else if (tab === '私人') {
          this.scopeShow = true
          this.openFlag = '0'
        }
      },
      tabChange(payload) {
        this.page.currentPage = 1
        this.filterText = ''
        this.personFlag = payload.name
        // console.log(this.oldPersonList)
        this.personList = this.oldPersonList
        if (payload.name === "1") {
          this.isPerson = true;
        } else {
          this.isPerson = false;
        }
        this.getTableList(payload.name)
        this._getTreeData();
      },
      stepMove(num) {
        this.activeName = (this.activeName - 0 + num).toString();
        this.rightTabActive = (this.rightTabActive - 0 + num).toString();
      },
      getCursetypeList() {
        http.post('/system/getCourseTypes.json').then(res => {
          if (res.data.code === _.ERR_OK) {
            this.cursetypeList = res.data.model
          } else {
          }
        }).catch(err => {
        })
      },
      getSubjectList() {
        http.post('/system/getScienceTypes.json').then(res => {
          if (res.data.code === _.ERR_OK) {
            this.subjectList = res.data.model
            let itemOne = {
              catalogName: "所有",
              id: ""
            };
            this.subjectList.unshift(itemOne);
          } else {
          }
        }).catch(err => {
        })
      },
      personClick(val) {
        this.getTableList(this.personFlag, val.id)
      },
      getUserInfo() {
        http.post('/getUserInfo.json').then(res => {
          if (res.data.code === _.ERR_OK) {
            this.hospitalId = res.data.model.hosId
            this.founder = res.data.model.userName
            saveLocalStorage(res.data.model.userName, 'userName')
          } else {
          }
        }).catch(err => {
        })
      },
      _AddCourse(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.openFlag==='0'){
              if(this.openMember===''){
                this.$confirm('未选择开放范围', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                }).then(() => {
                  this.saveReq()
                })
              } else {
               this.saveReq()
              }
            }else{
              this.saveReq()
            }
          } else {
            return false
          }
        })
      },
      saveReq() {
        let studyData = []
        for (let item of this.data) {
          studyData.push({
            studyPk: item.studyPk
          })
        }
        let caseList = []
        for (let item of this.dataVal) {
          caseList.push({
            id: item.id,
            creator: item.creator,
            creatorName: item.creatorName,
            isDelete: item.isDelete,
            caseName: item.caseName
          })
        }
        let isModify = getLocalStorage('isModify')
        let detailData = getLocalStorage('bianjiData')
        let addId = ''
        if(isModify){
          addId = detailData.id
        }
        let SelectCurse
        let SelectSubject
        if(this.selectCurse ==='专题讲座'  ||  this.selectCurse === ''){
          let selId
          for (let item of this.cursetypeList) {
            if(item.catalogName === '专题讲座'){
              selId = item.id
            }
          }
          SelectCurse = selId
        } else {
          SelectCurse = this.selectCurse
        }
        if(this.selectSubject ==='所有' || this.selectSubject ===''){
          SelectSubject = null
        } else {
          SelectSubject = this.selectSubject
        }

        let params = {
          id: addId,
          subject: this.form.CurseName,
          courseTypeId: SelectCurse,
          scienceTypeId: SelectSubject,
          keywords: this.keywords,
          openFlag: this.openFlag,
          remark: this.remark,
          studyList: studyData,
          caseList: caseList,
          attachList: this.oldAttachList || [],
          attendList: this.openMemberList,
        }
        for (let item of params.attachList) {
          for (var key in item) {
            if (
              key !== "fileid" &&
              key !== "attach_name" &&
              key !== "attach_type" &&
              key !== "atatch_size"
            ) {
              delete item[key];
            }
          }
        }
        http.post('/materia/editMateria.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            message(res.data.model, true)
            this.$router.go(-1)
          } else {
            message(res.data.msg, false)
          }
        }).catch(err => {
          errMsg(err)
        })
      },
      _returnback() {
        this.$router.go(-1)
      },
      changeGender(val){
        let gander;
        val.replace(/\s+/g, "") == "F" ? gander='女':gander= '男';
        return gander;
      },
      openMemberVal(val){
        this.openMember = val
      },
      openMemberData(val){
        this.openMemberList = val
      }
    },
    created() {
      this.getH()
      this.getCursetypeList()
      this.getSubjectList()
      this.getUserInfo()
      let isModify = getLocalStorage('isModify')
      if(isModify) {
        let detailData = getLocalStorage('bianjiData')
        if(detailData.scienceTypeId===undefined){
          this.selectSubject = '所有'
        }else{
          this.selectSubject = detailData.scienceTypeId
        }
        this.form.CurseName = detailData.subject
        this.selectCurse = detailData.courseTypeId
        this.keywords = detailData.keywords


        if(detailData.openFlag === '1') {   //开放范围修改部分
          this.scopeShow = false
          this.openFlag = '1'
          detailData.openFlag = '公开'
        } else if(detailData.openFlag === '0'){
          this.scopeShow = true
          this.openFlag = '0'
          detailData.openFlag = '私人'

          var examinePart = "";
          let par = {}
          for (let item of detailData.attendList) {
           if(item.attendType == '3'){
            par = {
              id: item.groupId,
              name: item.groupName,
              job: '',
              attebdType: item.attendType
            }
           }else if(item.attendType =='2'){
            par = {
              id: item.hosId,
              name: item.hosName,
              job: '',
              attebdType: item.attendType
            }
           }else if(item.attendType =='1'){
            par = {
              id: item.deptId,
              name: item.deptName,
              job: item.hosName,
              attebdType: item.attendType
            }
           }else{
            par = {
              id: item.userId,
              name: item.userName,
              job: item.docTitle,
              attebdType: item.attendType
            }
           }
            examinePart +="，" + par.name;
            if (examinePart.substr(0,1)=='，')
              examinePart=examinePart.substr(1);
          }
          this.openMember = examinePart
          this.openMemberList = detailData.attendList
        }

        this.form.resource = detailData.openFlag
        this.remark = detailData.remark
        for (let item of detailData.studyList) {
          item.examDate = nomalTime(item.examDate)
          item.patientSex = this.changeGender(item.patientSex)
          item.hosArea = changehosArea(item.hosArea)
          item.clinicType = changeclinicType(item.clinicType)
          // if(item.patientAge!==undefined){
          //   item.patientAge = item.patientAge + changeAge(item.ageUnit)
          // } else {
          //   item.patientAge = ''
          // }
        }
        this.data = detailData.studyList
        this.studyList = this.data
        for (let item of detailData.caseList) {

          if(item.caseSex === 'F' || item.caseSex === '0') {
            item.caseSex = '女'
          } else {
            item.caseSex = '男'
          }
          if(item.privateType === 0) {
            item.privateType = "公共"
          } else if(item.privateType === 1) {
            item.privateType = "个人"
          } else if(item.privateType === 2) {
            item.privateType = "部门公开"
          } else if(item.privateType === 3) {
            item.privateType = "医院公开"
          }
          if (item.ageUnit === '4') {
            item.caseAge = item.caseAge + '岁'
          } else if (item.ageUnit === '3') {
            item.caseAge = item.caseAge + '个月'
          } else if (item.ageUnit === '2') {
            item.caseAge = item.caseAge + '周'
          } else if (item.ageUnit === '1'){
            item.caseAge = item.caseAge + '天'
          } else if(item.ageUnit === '5'){
            item.caseAge = item.caseAge + '小时'
          }
        }
        this.oldAttachList = detailData.attachList || []
        this.dataVal = detailData.caseList
        this.tableData = this.dataVal
        if (detailData.attachList.length > 0) {
          for (let item of detailData.attachList) {
            if (item.attach_type === 'file') {
              this.updateFileList.push(item)
            } else {
              this.updatePicList.push(item)
            }
          }
        }
        for (let item of detailData.attachList) {
          delete item.createDate
        }
        this.attachList = detailData.attachList || []
      }
      if (this.$route.name.indexOf("Modify") > -1) {
        this.cutOut = 'Modify'
      }
    },
    watch: {
      activeName1(c, o) {
        if (c == 'first') {
          this.text = '从本院影像选择'
          this.addBtn = true
        } else if (c == 'second') {
          this.text = '从病例库中选择'
          this.addBtn = true
        } else if (c == 'third') {
          this.addBtn = false
        }
      },
      popShow(c) {
        this.getTableList()
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .commonAddcourse
    height: calc(100vh - 50px)
    overflow-y: auto
  .addCourse
    height: 46px
    float:right
    background: $color-background-d
    margin-bottom: -10px

  .tabs-content
    overflow: hidden
    background: $color-index-text

  .addBtn
    float: right
    width: 120px
    height: 27px
    position: relative
    top: 11px
    right: 20px
    line-height: 27px
    text-align: center
    cursor: pointer
    background: $color-btn
    color: $color-index-text
    border-radius: 3px
    z-index: 233

  .search
    background: $color-index-text
    margin-bottom: 15px
    padding: 15px 0


  .scient
    position: relative
    left: -8px

  .arrow_first
    position: relative;
    top: 16px;
    left: 130px;

  .arrow_second
    position: relative
    top: 16px
    left: 250px

  .tabs-text
    position: relative
    // margin-top: -15px
    // top: -34px
    .el-tabs
      margin-top -10px
  .file-block
    min-height: 342px
  .radius_input
    min-width: 200px
    width: 70%
    background: #f2f2f2
    height: 24px
    border-radius: 20px
    position: absolute
    right: 20px
    top: -14px
    padding: 0 20px

  .point
    position: absolute
    right: 20px
    top: 5px

  ._input
    min-width: 200px
    width: 100%
    background: #f2f2f2
    height: 24px
    border-radius: 20px
    right: 20px
    top: -14px
    padding: 0 20px
    box-sizing: border-box;

  .secPoint
    right: 10px

  ._inputTable
    top: 6px

  .btn-box
    clear:both
    text-align: center
    margin: 20px 0
    .save, .cancel
      width: 180px
      height: 35px
      border: none
      color: $button-text-color
    .save
      background: $color-background-hover
      margin:0 80px
    .commonBtn
      width: 90px
    .cancel
      background: $button-del
</style>



// WEBPACK FOOTER //
// addCourseWare.vue?36b1d2e1